import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';

import { Types, Creators } from 'store/ducks/interest/delete';
import { Creators as ListCreators } from 'store/ducks/interest/list';
import { callApi } from 'store/sagas/auth';
import { push } from 'connected-react-router';



function* getInterestDelete({ payload }) {
  try {
    const { id } = payload;
    const request = call(api.delete, `/v1/admin/users/interests/${id}`);
    const response = yield call(callApi, request);
    yield put(Creators.getInterestDeleteSuccess());
    // Remove a categoria deletada da lista
    const { categoryList, categoryListTotal } = yield select(
      state => state.blog.category.list,
    );

    yield put(
      ListCreators.getInterestListSuccess({
        data: categoryList.filter(doc => doc.id !== id),
        total: categoryListTotal - 1,
      }),
    );
    yield put(push(`/interests`));
  } catch (err) {
    yield put(Creators.getInterestDeleteFailure('Erro ao buscar na API'));
  }
}

// Individual exports for testing
export default function* productListSaga() {
  yield all([takeLatest(Types.GET_DELETE_REQUEST, getInterestDelete)]);
}
